import { DateRangePicker } from "react-date-range";
import { useState } from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./WoshDateRangePicker.scss";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import { Button, useMediaQuery } from "@mui/material";

export default function WoshDateRangePicker({ toOpen, toClose, handleApply }) {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const onApplyClicked = () => {
    handleApply(range);
    toClose();
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    toClose();
  };

  return (
    <Dialog
      open={toOpen}
      maxWidth="lg"
      sx={{
        "& .rdrDefinedRangesWrapper": {
          display: "none",
        },
      }}
    >
      <DialogActions>
        <Button>
          <CloseIcon onClick={() => handleClose()} />
        </Button>
      </DialogActions>
      <DateRangePicker
        ranges={range}
        onChange={(range) => {
          setRange([range.selection]);
        }}
        direction="horizontal"
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        staticRanges={[]}
        inputRanges={[]}
        editableDateInputs={false}
        months={isMobile ? 1 : 2}
        color="red"
        fixedHeight={true}
        rangeColors={["#0A6073"]}
      />
      <Button className="apply-btn" onClick={onApplyClicked}>
        Apply
      </Button>
    </Dialog>
  );
}
